import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IMonitoringState } from "./monitoring";

const exampleStateSelector = createFeatureSelector<IMonitoringState>('monitoring');

export const selectOperationMonitoring = createSelector(
  exampleStateSelector,
  (state: IMonitoringState) => state.operationMonitoring
);

export const selectOperationMonitoringDetail = createSelector(
  exampleStateSelector,
  (state: IMonitoringState) => state.operationMonitoringDetail
);